export const comActivityTypes = [
  `Call`,
  `Form`,
  `Imported Form`,
  `Chat`,
  `Online Scheduler`,
  `Virtual Consultation`,
  `Scheduler`,
  `FollowUp`,
]
